import React from "react";
import { Modal, Button } from "react-bootstrap";

const PayoutDetailModal = ({ show, onHide, payout }) => {
  if (!payout) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Payout Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Hub:</strong> {payout.hubId ? payout.hubId.name : "N/A"}
        </p>
        <p>
          <strong>Client:</strong>{" "}
          {payout.clientId ? payout.clientId.name : "N/A"}
        </p>
        {/* <p>
          <strong>Company :</strong>{" "}
          {payout.companyId ? payout.companyId.company : "N/A"}
        </p> */}
        <p>
          <strong>Company :</strong>{" "}
          {payout.companyId
            ? `${payout.companyId.company} (${payout.companyId.vehiclename}) (${payout.companyId.vehicle_type})`
            : "N/A"}
        </p>

        <p>
          <strong>Vehicle Type :</strong> {payout.vehicleType}
        </p>
        <p>
          <strong>Payout Days :</strong> {payout.payoutDays}
        </p>
        <p>
          <strong>Amount Order Picked :</strong>{" "}
          {payout.amount ? payout.amount.orderPicked : "-"}
        </p>
        <p>
          <strong>Amount Order Delivered:</strong>{" "}
          {payout.amount ? payout.amount.orderDeliver : "-"}
        </p>
        <p>
          <strong> Trips Amount :</strong>{" "}
          {payout.amount ? payout.amount.trips : "-"}
        </p>
        <p>
          <strong>Shift :</strong> {payout.shift}
        </p>
        <p>
          <strong>Threshold Value :</strong> {payout.threshold}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PayoutDetailModal;
